<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flexc-cen-x fixed" >
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工作台</el-breadcrumb-item>
    </el-breadcrumb>
    <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
      <el-option
        v-for="item in DianList"
        :key="item.ID"
        :label="item.StoresName"
        :value="item.ID">
      </el-option>
    </el-select>

    </div>
   <div style="width:100%;padding-top:30px">
      <div class="flex-spc-x" style="width:100%">
              <div class="box cursor">
                  <div class="textTitle">今日收入     
                  <el-tooltip class="item" effect="dark" content="所有今日，在线购卡、发卡、续卡总费用，在线购课。" placement="top-start">
                    <i class="el-icon-question" style="color:#808080"></i>
                      <!-- <el-button>上左</el-button> -->
                    </el-tooltip>
                  </div>
                  <div class="flexc-cen-x money">
                    <div class="rmb" v-if="showNum == true">￥</div>
                    <div class="" v-if="showNum == true"> {{list.allsumAmountjt}}</div>
                    <div class=""  v-if="showNum != true"> ***</div>
                  </div>
                  <div class="bottomTitle" v-if="showNum == true">昨日收入 ￥{{list.allsumAmountzt}} </div>
                   <div class="bottomTitle" v-else>昨日收入 *** </div>
                
              </div>
              <div class="box cursor">
                  <div class="textTitle">意向{{WZHYName}}  
                  <el-tooltip class="item" effect="dark" content="后台录入意向会员或者非会员在线注册。" placement="top-start">
                    <i class="el-icon-question" style="color:#808080"></i>
                      <!-- <el-button>上左</el-button> -->
                    </el-tooltip>
                  </div>
                  <div class="flexc-cen-x money">
                    <div class="rmb"></div>
                    <div class="">{{list.allCountyx}} </div>
                  </div>
                  <div class="bottomTitle">本月新增 {{list.allCountbyyx}} </div>
              </div>
              <div class="box cursor">
                  <div class="textTitle">今日新增{{WZHYName}}    
                  <el-tooltip class="item" effect="dark" content="今日新增录入的会员。" placement="top-start">
                    <i class="el-icon-question" style="color:#808080"></i>
                      <!-- <el-button>上左</el-button> -->
                    </el-tooltip>
                  </div>
                  <div class="flexc-cen-x money">
                    <div class="rmb"></div>
                    <div class="">{{list.allCountjt}}</div>
                  </div>
                  <div class="bottomTitle">昨日新增 {{list.allCountzt}} </div>
                
              </div>
              <div class="box cursor">
                  <div class="textTitle">{{WZHYName}}总数   
                  <el-tooltip class="item" effect="dark" content="系统内所有会员条数。" placement="top-start">
                    <i class="el-icon-question" style="color:#808080"></i>
                      <!-- <el-button>上左</el-button> -->
                    </el-tooltip>
                  </div>
                  <div class="flexc-cen-x money">
                    <div class="rmb"></div>
                    <div class="">{{list.allCount}}</div>
                  </div>
                  <div class="bottomTitle">本月新增 {{list.allCountby}} </div>
                
              </div>
      </div>
      <div class="flex-spc-x" style="width:100%">
        <div class="box1">
          <div class="flex-spc-x">
            <div class="box3 flex-xy">
                <div class="flex-spc-x" style="width:90%;height:25%;margin-top:5px">
                  <div class="box3Ttile">今日需{{name}}人数</div>
                  <el-button type="text" style="font-size: 14px;" @click="toPush()">更多</el-button>
                </div>
                <div class="flex-xy" style="width:95%;height:75%">
                    <div class="num" style="margin-top:-10px">
                     {{list.dhxcount}}
                    </div>
                </div>
            </div>
            <div class="box3 flex-xy">
                <div class="flex-spc-x" style="width:90%;height:25%;margin-top:5px">
                  <div class="box3Ttile">今日已{{name}}人数</div>
                  <el-button type="text" style="font-size: 14px;" @click="toPush()">更多</el-button>
                </div>
                <div class="flex-xy" style="width:95%;height:75%">
                    <div class="num" style="margin-top:-10px">
                      {{list.yhxcount}}
                    </div>
                </div>
            </div>
            <div class="box3 flex-xy">
                <div class="flex-spc-x" style="width:90%;height:25%;margin-top:5px">
                  <div class="box3Ttile">续期预警</div>
                  <el-button type="text" style="font-size: 14px;" @click="toxuqi()">更多</el-button>
                </div>
                <div class="flex-xy" style="width:95%;height:75%">
                    <div class="num" style="margin-top:-10px">
                       {{list.allcountyj}}
                    </div>
                </div>
            </div>
            <div class="box3 flex-xy">
                <div class="flex-spc-x" style="width:90%;height:25%;margin-top:5px">
                  <div class="box3Ttile">短信条数</div>
                  <el-button type="text" style="font-size: 14px;" @click="toMail()">更多</el-button>
                </div>
                <div class="flex-xy" style="width:95%;height:75%">
                    <div class="num" style="margin-top:-10px">
                     {{list.SyNumber}}
                    </div>
                </div>
            </div>
          </div>  
          <div class="flex-spc-x" >
             <div class="box4 flex-xy" @click="toBirthday">
               <img src="../../assets/icon/birthday.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">生日提醒</div>
             </div>
              <div class="box4 flex-xy" v-if="iscdyy==0 && IsZJYY==0" @click="toPai">
               <img src="../../assets/icon/paiban.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">{{WZPBName}}</div>
             </div>
             <div class="box4 flex-xy" v-if="IsZJYY==1" @click="toPai2">
               <img src="../../assets/icon/paiban.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">{{ZJYYName}}</div>
             </div>
             <div class="box4 flex-xy" v-if="iscdyy==1" @click="toPai1">
               <img src="../../assets/icon/paiban.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">预约详情</div>
             </div>
              <div class="box4 flex-xy" v-if="iscdyy==0 && IsZJYY==0"  @click="toYy">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">预约</div>
             </div>
             <div class="box4 flex-xy" v-if="IsZJYY==1"  @click="toYy2">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">员工</div>
             </div>
             <div class="box4 flex-xy" v-if="iscdyy==1" @click="toYy1">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">{{WZCDName}}预约</div>
             </div>
             <div class="box4 flex-xy" @click="toVip">
               <img src="../../assets/icon/vip.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">{{WZHYName}}</div>
             </div>
          </div>
          <div class="flex-spc-x">
             <div class="box4 flex-xy" @click="toke">
               <img src="../../assets/icon/kehu.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">意向{{WZHYName}}</div>
             </div>
              <div class="box4 flex-xy" v-if="iscdyy==0" @click="toProject">
               <img src="../../assets/icon/project.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">{{WZXMName}}</div>
             </div>
             <div class="box4 flex-xy"  v-if="iscdyy==1" @click="toProject1">
               <img src="../../assets/icon/project.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">{{WZCDName}}</div>
             </div>
              <div class="box4 flex-xy" @click="toMen">
               <img src="../../assets/icon/mendian.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">门店管理</div>
             </div>
              <div class="box4 flex-xy" @click="toPhone">
               <img src="../../assets/icon/phone.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500"> 手机端设置</div>
             </div>
          </div>
        </div>
         <div class="box2">
            <h4 v-if="iscdyy==0" class="pm">{{WZXMName}}预约排名(截止至昨天)</h4>
            <h4 v-if="iscdyy==1" class="pm">{{WZCDName}}预约排名(截止至昨天)</h4>
            <ul class="rankingList___2qU5M" v-if="q9 == true">
              <li style="width:100%" v-for="(items,index) in list.listProject">
                <span class="active___3n5dI" v-if="index < 3">{{index + 1}}</span>
                 <span class="">{{index + 1}}</span>
                <span >{{items.ProjectName}}</span>
                <span style="margin-right:10px">{{items.allCount}}次</span>
              </li>
            </ul>
            <div v-else class="flex-xy " style="margin-top:50%">
                暂无权限
            </div>
         </div>
      </div>
      <div class="flexc-cen-x" style="width:100%">
        <div class="box5 flex-xy" v-if="isProject == 1 || iscdyy==1">
          <div class="box3Ttile">小程序二维码</div>
          <img v-image-preview :src="xcxPhth" style="width:100px;height:100px;margin-top:15px" alt="" srcset="">
          <div class="bottomTitle1">微信扫描查看</div>
        </div>
        <div  class="box5 flex-xy" style="margin-left:1.5%" v-if="ispaiban == 1">
          <div class="box3Ttile">小程序{{name}}码</div>
          <img v-image-preview  :src="xcxPhthpd" style="width:100px;height:100px;margin-top:15px" alt="" srcset="">
          <div class="bottomTitle1">微信扫描查看</div>
        </div>
        <div  class="box5 flex-xy" style="margin-left:1.5%">
          <div class="box3Ttile">客服二维码</div>
          <img v-image-preview  :src="kefuQrimg" style="width:100px;height:100px;margin-top:15px" alt="" srcset="">
          <div class="bottomTitle1">微信扫描查看</div>
        </div>

      </div>
   </div>
 

    <!-- 搜索筛选 -->
  </div>
</template>
<script>

import Pagination from "../../components/Pagination";
 import { baseUrl } from "../../config/env.js";
 import { ajax } from "../../config/fetch.js";
 import {getLoginToken} from "@/api/getData";
export default {
  data() {
    return {
      open:true,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      SelectStoresID:localStorage.getItem("StoresID"),
      list:[],
      showNum:false,
      xcxPhthpd:'',
      ispaiban:'',
      title: "添加",
      editForm: {
        deptId: "",
        deptName: "",
        deptNo: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
        ],
        deptNo: [
          { required: true, message: "请输入部门代码", trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
      q8:false,
      q9:false,
      q10:false,
      q11:false,
      q15:false,
      q16:false,
      q18:false,
      Limits:[],
      StoresType:'',
      showNum:false,
      name:'',
      isProject:'',
      iscdyy:'',
      WZYGName:'',
      WZHYName:'',
      WZXMName:'',
      WZPBName:'',
      kefuQrimg:'',
      xcxPhth:'',
      xcxPhthls:'',
      WZCDName:'',
      IsZJYY:'',
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.WZCDName = localStorage.getItem('WZCDName')
    this.ZJYYName = localStorage.getItem('zzjy')

    
    this.isProject = localStorage.getItem('isProject')
    this.iscdyy = localStorage.getItem('iscdyy')
    this.IsZJYY = localStorage.getItem('iszjyy')

    
    this.ispaiban = localStorage.getItem('ispaiban')
      this.StoresType = localStorage.getItem('StoresType')
      if(this.StoresType == 1){
          this.name = '签到'

      }  else {
          this.name = '核销'

      }     
      if(localStorage.getItem('isAdmin') == 1){
         this.showNum  = true
         this.q1 = true
         this.q2 = true
         this.q3 = true
         this.q4 = true
         this.q5 = true 
         this.q6 = true 
         this.q7 = true 
         this.q8 = true
         this.q9 = true
         this.q10 = true
         this.q11 = true
         this.q15= true
         this.q16= true
         this.q18= true
      }
        this.getDianList()
        this.getList()
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
          if(items == 21)
            this.q1 = true
          if(items == 841)
            this.q2 = true
          if(items == 138)
            this.q3 = true
          if(items == 85)
            this.q4 = true
          if(items == 71)
            this.q5 = true 
          if(items == 41)
            this.q6 = true 
          if(items == 821)
            this.q7 = true 
          if(items == 831)
            this.q8 = true 
          if(items == 61)
            this.q9 = true
          if(items == 1312)
            this.q10 = true
          if(items == 132)
            this.q11 = true
            if(items == 151)
            this.q15 = true
            if(items == 161)
            this.q16 = true
            if(items == 181)
            this.q16 = true
            // if(items == )
      })
    // this.getdata(this.formInline);
    // this.getLoginToken()
    //  const loading = this.$loading({
    //       lock: true,
    //       text: '加载中...',
    //       spinner: 'el-icon-loading',
    //       background: 'rgba(0, 0, 0, 0.7)'
    //     });
    //     // setTimeout(() => {
    //     //   loading.close();
    //     // }, 2000);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {


    toxuqi(){
      if(this.q2 == true){
          this.$router.push({ path: '/vip/renew'})
      } else {
         this.$message.info("权限不足");
      }
        
    },
    toMail(){
      if(this.q3 == true ){
          this.$router.push({ path: `/setting/SMSSettingInfo/${this.SelectStoresID}`})
      } else {
          this.$message.info("权限不足");
      }
     
    },
    toBirthday(){   
      if(this.q4 == true){
      this.$router.push({ path: '/vip/birthday'})
      } else {
          this.$message.info("权限不足");
      }
     
    },
    toPai2(){
      this.$router.push({ path: '/board/board'})

    },
    toPai1(){
      if(this.q18 == true){
      this.$router.push({ path: '/site/siteMainList'})
      }else{
        this.$message.info("权限不足");
      }
    },
    toPai(){
      if(this.q5 == true && this.isProject  == 1){
          this.$router.push({ path: '/arrange/arrange'})
      } else {
          this.$message.info("权限不足");
      }
    
    },toYy2(){
      this.$router.push({ path: '/personnel/personnel'})

    },toYy1(){
      if(this.q16 == true ){
      this.$router.push({ path: '/site/siteMain'})
    } else {
          this.$message.info("权限不足");
      }

    },
    toYy(){
      if(this.q6 == true && this.isProject  == 1){
         this.$router.push({ path: '/appointment/appointment'})
      } else {
        this.$message.info("权限不足");
      }
   
    },
    toVip(){  
      if(this.q7 == true){
        this.$router.push({ path: '/vip/vip'})
      } else {
        this.$message.info("权限不足");
      }
    },
    toke(){
      if(this.q8 == true){
       this.$router.push({ path: '/vip/customer'})
      } else {
        this.$message.info("权限不足");
      }
    },
    toProject1(){
      if(this.q15 == true){
      this.$router.push({ path: '/site/siteList'}) 
    } else {
        this.$message.info("权限不足");
      }

    },
    toProject(){
      if(this.q9 == true && this.isProject  == 1){
          this.$router.push({ path: '/project/project'})
      } else {
        this.$message.info("权限不足");
      }
     
    },
    toPhone(){
      if(this.q10 == true && this.isProject  == 1){
      this.$router.push({
        path:`/phoneSetting/phoneSetting/${this.SelectStoresID}`
      })
     }else {
      if(this.q10== true && this.iscdyy ==1){
        this.$router.push({
        path:`/phoneSetting/phoneSetting/${this.SelectStoresID}`
      })
      }else{
        this.$message.info("权限不足");

      }
      }
      // this.$router.push({ path: '/phoneSetting/phoneSetting'})
    },
    toMen(){
      if(this.q11 == true){
      this.$router.push({
        path: `/Thailand/Thailand/${this.SelectStoresID}`,
      });
      } else {
        this.$message.info("权限不足");
      }
    },
    toPush(){
      if(this.q1 == true && this.isProject == 1){
        if(this.IsZJYY==1){
          this.$router.push({ path: '/board/board'})

        }else{
          this.$router.push({ path: '/billboard/billboard'})

        }

      }else if(this.q1 == true && this.iscdyy == 1){
          this.$router.push({ path: '/site/siteMainList'})

      }  else {
          this.$message.info("权限不足");
      }
     
    },
    getList(){
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
       this.ajax('getHomeInfo.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.list =res.data
              that.kefuQrimg = res.kefuQrimg
              that.xcxPhth = res.xcxPhth
              that.xcxPhthls = res.xcxPhthls
              that.xcxPhthpd = res.xcxPhthpd
              localStorage.setItem("xcxPhth1", res.xcxPhth);
              localStorage.setItem("xcxPhthls", res.xcxPhthls);
              localStorage.setItem("xcxPhthpd", res.xcxPhthpd);
            }
            loading.close();
      })
    },
    changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      this.getList()
      // this.getImg()
    },
      getDianList(){
       var data = { 
          SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
    },
 
 
  
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.deptId = row.deptId;
        this.editForm.deptName = row.deptName;
        this.editForm.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.editForm.deptId = "";
        this.editForm.deptName = "";
        this.editForm.deptNo = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          deptSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
  
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("公司保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deptDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("公司删除失败，请稍后再试！");
            });
        })
        .catch(() => {
            ;
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>
<style scoped>
.rankingList___2qU5M li span:last-child {
    float: right;
}
.rankingList___2qU5M li span.active___3n5dI {
    background-color: #fab938 !important;
    color: #fff !important;
}
.rankingList___2qU5M li span:first-child {
    background-color: #f5f5f5;
    border-radius: 20px;
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    margin-right: 10px;
    height: 20px;
    line-height: 20px;
    width: 20px;
    text-align: center;
    color:black;
}
.rankingList___2qU5M li{
    zoom: 1;
    margin-top: 16px;
}
.rankingList___2qU5M li span {
    color: rgba(0,0,0,.65);
    font-size: 12px;
    line-height: 22px;
}
.rankingList___2qU5M {
    margin: 25px 0 0;
    padding: 0;
    list-style: none;
    height: 300px;
    overflow:auto;
}
.bottomTitle{
    margin-top: 12px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666;
    line-height: 20px;
}
.bottomTitle1{
    margin-top: 12px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666;
    /* line-height: 20px; */
}
.rmb{
  font-size: 12px; line-height: 1;
}
.money{
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    margin-top: 12px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #4c4c4c;
    line-height: 46px;
}
.textTitle{
    margin-right: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #191919;
    line-height: 22px;
}
 .box{
    cursor: pointer;
    width: 24%;
    height: 160px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
  }
  .box1{
 
    width: 74.7%;
    height: 362px;
    /* padding: 20px; */
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    /* border: 1px solid #ececec; */
    /* box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%); */
  }
  .box2{
    cursor: pointer;
    width: 24%;
    height: 362px;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .pm{
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: "tnum";
    margin-top: 0;
    margin-bottom: 0.5em;
    color: rgba(0,0,0,.85);
    font-weight: 500;
  }

 .box3{
    cursor: pointer;
    width: 24%;
    height: 130px;
    
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .box3Ttile{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #191919;
  }
  .num{
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #4c4c4c;
    line-height: 46px;
  }
   .box4{
    cursor: pointer;
    width: 24%;
    height: 100px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
   border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
 .box5{
    cursor: pointer;
    height: 200px;
    width:180px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
</style>

 



// WEBPACK FOOTER //
// src/views/home/home.vue